import { render, staticRenderFns } from "./frontHeaderNew.vue?vue&type=template&id=2924dd96&"
import script from "./frontHeaderNew.vue?vue&type=script&lang=js&"
export * from "./frontHeaderNew.vue?vue&type=script&lang=js&"
import style0 from "./frontHeaderNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports